import { router } from '@inertiajs/react'
import { ItemDetail } from '@/components/items/ItemDetail'
import type { Item } from '@/components/items/types'

interface Props {
  item: Item
}

export default function ItemsShow({ item }: Props) {
  const handleBack = () => {
    router.visit('/items')
  }

  const handleFlagAsGem = () => {
    router.post(`/items/${item.id}/flag_as_gem`)
  }

  const handleUnflagGem = () => {
    router.delete(`/items/${item.id}/unflag_gem`)
  }

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this item?')) {
      router.delete(`/items/${item.id}`)
    }
  }

  const handleViewOriginal = () => {
    if (item.sourceUrl) {
      window.open(item.sourceUrl, '_blank')
    }
  }

  const handleCopyContent = () => {
    navigator.clipboard.writeText(item.content)
  }

  const handleViewReport = (reportId: string) => {
    router.visit(`/reports/${reportId}`)
  }

  return (
    <ItemDetail
      item={item}
      onBack={handleBack}
      onFlagAsGem={handleFlagAsGem}
      onUnflagGem={handleUnflagGem}
      onDelete={handleDelete}
      onViewOriginal={handleViewOriginal}
      onCopyContent={handleCopyContent}
      onViewReport={handleViewReport}
    />
  )
}
